var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBias(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.458333 26.458334",
    height: 100,
    width: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#b9b9b9",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b9b9b9",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2) rotate(180) translate(6,0)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 0.0,0.0 L 5.0,-5.0 L -12.5,0.0 L 5.0,5.0 L 0.0,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.107619,-0.9260235)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5135417,0.79375001)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 5.291667,
    height: 26.458334,
    x: -36.975521,
    y: 270.67392,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: -36.816765,
    y: 291.36444
  }), /*#__PURE__*/React.createElement("rect", {
    y: 286.39023,
    x: -36.816765,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: -36.816765,
    y: 281.41605
  }), /*#__PURE__*/React.createElement("rect", {
    y: 276.44186,
    x: -36.816765,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: -36.816765,
    y: 271.46765
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 271.20309,
    x: -36.869686,
    height: 25.4,
    width: 5.0799999,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79375005,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#TriangleOutS)"
    },
    d: "m -27.953227,274.74846 h 5.602046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -27.953227,279.72266 h 3.412179",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79374993,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#marker2404)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79374999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#marker2572)"
    },
    d: "m -27.953228,284.69685 h 2.086885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -35.679019,289.67104 H -38.18328",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79374999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#marker2632)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 0.79374999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerEnd: "url(#marker2698)"
    },
    d: "M -35.679019,294.64525 H -40.34739"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBias);
export default __webpack_public_path__ + "static/media/bias.b2468eb050f4ae27831a5bedc1b779be.svg";
export { ForwardRef as ReactComponent };